import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstEgresosHacienda = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_egresos_hacienda', 
        name: 'Listado Egresos Hacienda', 
        component: ViewLstEgresosHacienda,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
